<template>
  <div class="hotShow">
    <div class="title">
      {{TLang('全国热映','my')}}
    </div>
    <div class="showList">
      <div
        v-for="(item, index) in info"
        :key="index"
        @click="toDetail(item.id)"
        style="cursor:pointer"
      >
        <div class="goods">
          <div class="imgWrap">
            <img :src="item.imgUrl" alt="" class="goodsImg" />
          </div>
          <div class="infoList">
            <div class="title">{{ item.name }}</div>

            <p class="time" :title="item.timeInfo">{{ item.timeInfo }}</p>

            <div
              class="address"
              :title="item.venueName + ' | ' + item.cityName"
            >
              <span class="detail">{{ item.venueName }}</span
              ><span class="city">{{ item.cityName }}</span>
            </div>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.timeInfo"
              placement="top"
            >
              <div class="time">{{ item.timeInfo }}</div>
            </el-tooltip> -->
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.venueName + item.cityName"
              placement="top"
              :value="item.disabled"
            >
              <div class="address">
                <span class="detail">{{ item.venueName }}</span
                ><span class="city">{{ item.cityName }}</span>
              </div>
            </el-tooltip> -->
            <Price
              class="price"
              size="small"
              :price="item.sellingPrice"
              :onlyOnePrice="item.onlyOnePrice"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Price from "@/components/index/price.vue";
import { unionFlag } from "@/utils";
export default {
  name: "hot",
  data() {
    return {};
  },
  props: {
    info: Array
  },
  methods: {
    toDetail(id) {
      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     id
      //   }
      // });
      let union = unionFlag();
      console.log(union);
      let { city } = this.$route.query;
      window.open(
        `/drama_pc/detail?id=${id}&city=${city}` +
          (union ? `&union=${union}` : ""),
        this.isFeishuOrDingding ? "_self" : "_blank"
      );
    }
  },
  components: {
    Price
  }
};
</script>
<style>
.el-tooltip__popper.is-dark {
  margin-bottom: 5px !important;
  line-height: 0.2;
}
</style>
<style lang="less" scoped>
.hotShow {
  padding: 24px 16px 0;
  .title {
    color: #999999;
    font-size: 14px;
    line-height: 19px;
  }
  .showList {
    margin-top: 16px;
  }
  .goods {
    margin-bottom: 24px;
    .clearfix;
    .imgWrap {
      float: left;
    }
    .goodsImg {
      width: 86px;
      height: 115px;
    }
    .infoList {
      width: 128px;
      float: left;
      margin-left: 8px;
      position: relative;
      height: 115px;
    }
    .title {
      color: #000;
      font-size: 14px;
      height: 36px;
      line-height: 18px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .time {
      font-size: 12px;
      color: #808a94;
      margin-top: 8px;
      height: 17px;
      line-height: 17px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .address {
      font-size: 12px;
      line-height: 17px;
      color: #808a94;
      margin-top: 4px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      .detail {
        padding-right: 2px;
        border-right: 1px solid #ededed;
      }
      .city {
        padding-left: 2px;
      }
    }
    .price {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
